<template>
  <v-app>
    <v-app-bar app fixed height="48" flat color="white">
      <div class="d-flex align-center">
        <v-img src="@/assets/logo.png" height="30" width="20" contain/>
        <div class="text-h5 ml-3 blue--text text--darken-3 font-weight-medium">PURTRAK</div>
      </div>
    </v-app-bar>
    <v-main>
      <v-container fluid fill-height>
        <v-row justify="center">
          <router-view/>
        </v-row>
      </v-container>
    </v-main>

    <v-footer app class="white text-caption">
      <v-spacer/>
      &copy;Purtrak Inc. 2022
      <router-link to="/terms" class="mx-3">Terms of use</router-link>
      <router-link to="/privacy">Privacy policy</router-link>
      <v-spacer/>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
